import { render, staticRenderFns } from "./ManageCard.vue?vue&type=template&id=bfc1718e&scoped=true"
import script from "./ManageCard.vue?vue&type=script&lang=js"
export * from "./ManageCard.vue?vue&type=script&lang=js"
import style0 from "./ManageCard.vue?vue&type=style&index=0&id=bfc1718e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfc1718e",
  null
  
)

export default component.exports